import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const CmsTileModalMobileHeaderContainer = styled.div`
  width: 100%;
  height: 72px;
  flex-shrink: 0;
  background: white;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 0 42px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 31px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-bottom: 48px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const CmsTileModalMobileHeaderArrowsContainer = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-of-type) {
    margin-left: 49px;
  }

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    > *:not(:first-of-type) {
      margin-left: 44px;
    }
  }
`;
